import React, { useState } from 'react';

const DriverCard = ({ driver, onCall, onChat }) => {
  const [showVehicleDetails, setShowVehicleDetails] = useState(false);

  const renderStars = (rating) => {
    return Array.from({ length: 5 }, (_, i) => (
      <svg key={i} viewBox="0 0 24 24" fill={i < Math.floor(rating) ? '#ffd700' : 'rgba(10,22,40,0.12)'} className="w-3.5 h-3.5">
        <path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z" />
      </svg>
    ));
  };

  return (
    <div className="card-elevated p-4">
      <div className="flex items-center gap-3">
        {/* Driver avatar */}
        <div className="relative flex-shrink-0">
          <div className="w-14 h-14 rounded-2xl bg-gradient-to-br from-[#0a1628] to-[#1a365d] flex items-center justify-center text-2xl shadow-md">
            {driver?.avatar || '👨🏾‍✈️'}
          </div>
          <div className="absolute -bottom-1 -right-1 w-4 h-4 rounded-full bg-green-400 border-2 border-white"></div>
        </div>

        {/* Driver info */}
        <div className="flex-1 min-w-0">
          <div className="flex items-center justify-between">
            <p className="heading-3">{driver?.name}</p>
            <button
              onClick={() => setShowVehicleDetails(!showVehicleDetails)}
              className="text-xs text-[#0a1628]/40 hover:text-[#0a1628] transition-colors font-semibold"
            >
              {showVehicleDetails ? 'Less' : 'Details'}
            </button>
          </div>
          <div className="flex items-center gap-1 mt-0.5">
            {renderStars(driver?.rating)}
            <span className="text-xs font-bold text-[#0a1628]/60 ml-1">{driver?.rating}</span>
            <span className="caption-text ml-1">({driver?.trips} trips)</span>
          </div>
          <div className="flex items-center gap-2 mt-1.5">
            <span className="text-xs bg-[#0a1628]/8 text-[#0a1628]/60 rounded-lg px-2 py-0.5 font-semibold">
              {driver?.vehicleType}
            </span>
            <span className="text-xs bg-[#ffd700]/15 text-[#0a1628] rounded-lg px-2 py-0.5 font-black tracking-wider">
              {driver?.licensePlate}
            </span>
          </div>
        </div>
      </div>

      {/* Vehicle details (expandable) */}
      {showVehicleDetails && (
        <div className="mt-3 pt-3 border-t border-[#0a1628]/8 grid grid-cols-3 gap-2">
          {[
            { label: 'Vehicle', value: driver?.vehicleName },
            { label: 'Color', value: driver?.vehicleColor },
            { label: 'Year', value: driver?.vehicleYear },
          ]?.map(item => (
            <div key={item?.label} className="text-center bg-[#0a1628]/4 rounded-xl p-2">
              <p className="caption-text">{item?.label}</p>
              <p className="text-xs font-bold text-[#0a1628] mt-0.5">{item?.value}</p>
            </div>
          ))}
        </div>
      )}

      {/* Action buttons - using new button system */}
      <div className="flex gap-2 mt-3">
        <button
          onClick={onCall}
          className="flex-1 flex items-center justify-center gap-2 py-3 px-4 rounded-xl bg-[#0a1628] text-[#ffd700] font-bold text-sm hover:bg-[#1a365d] transition-all active:scale-[0.97] shadow-[0_4px_12px_rgba(10,22,40,0.2)]"
        >
          <svg viewBox="0 0 24 24" fill="currentColor" className="w-4 h-4">
            <path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z" />
          </svg>
          Call Driver
        </button>
        <button
          onClick={onChat}
          className="flex-1 flex items-center justify-center gap-2 py-3 px-4 rounded-xl bg-[#ffd700]/15 text-[#0a1628] font-bold text-sm hover:bg-[#ffd700]/25 transition-all active:scale-[0.97] border-2 border-[#ffd700]/30"
        >
          <svg viewBox="0 0 24 24" fill="currentColor" className="w-4 h-4">
            <path d="M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-2 12H6v-2h12v2zm0-3H6V9h12v2zm0-3H6V6h12v2z" />
          </svg>
          Chat
        </button>
      </div>
    </div>
  );
};

export default DriverCard;
